import React from "react";

import SettingsModule from "@app/analytics/account/components/SettingsModule";
import { Divider } from "@app/analytics/account/components/styles";
import type { SettingModule } from "@app/analytics/account/types";

import GeneralSettings from "./GeneralSettings";
import NotificationSettings from "./NotificationSettings";
import ParticipantAccessSettings from "./ParticipantAccessSettings";
import ReportDistributionSettings from "./ReportDistributionSettings";

const ReportingModule = (props: SettingModule) => (
  <SettingsModule {...props}>
    <GeneralSettings />
    <Divider />
    <ParticipantAccessSettings />
    <ReportDistributionSettings />
    <Divider />
    <NotificationSettings />
  </SettingsModule>
);

export default ReportingModule;
